/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomFieldUpdate
 */
export interface CustomFieldUpdate {
    /**
     * 
     * @type {Array<{ [key: string]: string | undefined; }>}
     * @memberof CustomFieldUpdate
     */
    labels: Array<{ [key: string]: string | undefined; }>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomFieldUpdate
     */
    options: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldUpdate
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CustomFieldUpdate
     */
    order?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldUpdate
     */
    type: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomFieldUpdate
     */
    useForUploads?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomFieldUpdate
     */
    requireToUpload?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomFieldUpdate
     */
    nonUserEditable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldUpdate
     */
    validation?: CustomFieldUpdateValidationEnum;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldUpdate
     */
    regex?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CustomFieldUpdate
     */
    rangeMin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CustomFieldUpdate
     */
    rangeMax?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CustomFieldUpdate
     */
    numberOfDigits?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldUpdate
     */
    metadataPrefill?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CustomFieldUpdate
     */
    highlightExpiration?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomFieldUpdate
     */
    multipleResponse?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldUpdate
     */
    helpText?: string | null;
}

/**
* @export
* @enum {string}
*/
export enum CustomFieldUpdateValidationEnum {
    NumberOfDigits = 'number_of_digits',
    Regex = 'regex',
    Range = 'range'
}

export function CustomFieldUpdateFromJSON(json: any): CustomFieldUpdate {
    return CustomFieldUpdateFromJSONTyped(json, false);
}

export function CustomFieldUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomFieldUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'labels': json['labels'],
        'options': json['options'],
        'name': json['name'],
        'order': !exists(json, 'order') ? undefined : json['order'],
        'type': json['type'],
        'useForUploads': !exists(json, 'use_for_uploads') ? undefined : json['use_for_uploads'],
        'requireToUpload': !exists(json, 'require_to_upload') ? undefined : json['require_to_upload'],
        'nonUserEditable': !exists(json, 'non_user_editable') ? undefined : json['non_user_editable'],
        'validation': !exists(json, 'validation') ? undefined : json['validation'],
        'regex': !exists(json, 'regex') ? undefined : json['regex'],
        'rangeMin': !exists(json, 'range_min') ? undefined : json['range_min'],
        'rangeMax': !exists(json, 'range_max') ? undefined : json['range_max'],
        'numberOfDigits': !exists(json, 'number_of_digits') ? undefined : json['number_of_digits'],
        'metadataPrefill': !exists(json, 'metadata_prefill') ? undefined : json['metadata_prefill'],
        'highlightExpiration': !exists(json, 'highlight_expiration') ? undefined : json['highlight_expiration'],
        'multipleResponse': !exists(json, 'multiple_response') ? undefined : json['multiple_response'],
        'helpText': !exists(json, 'help_text') ? undefined : json['help_text'],
    };
}

export function CustomFieldUpdateToJSON(value?: CustomFieldUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'labels': value.labels,
        'options': value.options,
        'name': value.name,
        'order': value.order,
        'type': value.type,
        'use_for_uploads': value.useForUploads,
        'require_to_upload': value.requireToUpload,
        'non_user_editable': value.nonUserEditable,
        'validation': value.validation,
        'regex': value.regex,
        'range_min': value.rangeMin,
        'range_max': value.rangeMax,
        'number_of_digits': value.numberOfDigits,
        'metadata_prefill': value.metadataPrefill,
        'highlight_expiration': value.highlightExpiration,
        'multiple_response': value.multipleResponse,
        'help_text': value.helpText,
    };
}


